<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">设备ID : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.deviceId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">设备名称 : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属用户/ID : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入所属用户名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">手机号码 : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属分组/ID : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupId"
                  placeholder="请输入分组名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属网关/ID : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayId"
                  placeholder="请输入所属网关/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">类型选择 : </span>
              <div class="width300">
                <el-select class="width250" v-model="searchData.type" >
                  <el-option
                    v-for="(i, index) in OQuality"
                    :value="i.value"
                    :label="i.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
               
              @click="handleSearch"
              style="margin-bottom: 10px"
              class="marginLeft10"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
                
              @click="handleReset"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { qualityList } from "@/api/electric/quality";
import dayjs from "dayjs";
import qs from "qs";
import { exportExcel } from "@/components/exportExcel";
import { EQuality, MQuality, OQuality } from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "index",
  data() {
    return {
      searchData: {
        type: 1,
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      EQuality: EQuality,
      MQuality: MQuality,
      OQuality: OQuality,
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu:false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "设备ID",
            prop: "deviceId",
          },
          {
            label: "设备名称",
            prop: "name",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "所属网关",
            prop: "gatewayName",
          },
          {
            label: "24小时",
            prop: "hourNum",
          },
          {
            label: "7天",
            prop: "dayNum",
          },
          {
            label: "一年",
            prop: "yearNum",
          },
          {
            label: "总计数",
            prop: "totalNum",
          },
        ],
      },
      timeDialogShow: false,
      showLoadingTime: false,
      form: {
        exportID: "", //导出id
        timeType: 1, //导出时间选择
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      qualityList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        type:1
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //下载
    handleDownload(e) {
      this.form.timeType = 1;
      this.form.exportID = e.id;
      this.timeDialogShow = true;
    },
    handleClose() {
      this.timeDialogShow = false;
      console.log(111111);
    },
  },
};
</script>

<style scoped>
 ::v-deep  .el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #dcdfe6;
  border-radius: 4px !important;
  box-shadow: none !important;
}
 ::v-deep  .el-radio-button__inner {
  border: 1px solid #dcdfe6 !important;
}
 ::v-deep  .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 4px !important;
}
 ::v-deep  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  box-shadow: 0 0 0 0 #409eff;
}
</style>